var MaterializeInput = React.createClass({displayName: 'MaterializeInput',

	propsType: {
		placeholder: React.PropTypes.string,
		type: React.PropTypes.string,
		label: React.PropTypes.string,
		name: React.PropTypes.string,
		value: React.PropTypes.string,
		onChange: React.PropTypes.func
	},

	render: function () {
		return (
			React.createElement("div", {className: (this.props.className || '') + " input-field"}, 
				React.createElement("input", {id: this.props.name, 
					placeholder: this.props.placeholder, 
					type: this.props.type, 
					className: "validate", 
					onChange: this.props.onChange, 
					value: this.props.value}, 
					React.createElement("label", {htmlFor: this.props.name}, this.props.label)
				)
			)
		)
	}
});

module.exports = MaterializeInput;